import { useState, useEffect, useRef } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useAdmin } from '../../hooks/useAdmin';
import './BurgerMenu.css';

type MenuItem = {
  label: string;
  href?: string;
  external?: boolean;
  isAction?: boolean;
  onClick?: () => void;
};

type Props = { currentPage?: string };

export function BurgerMenu({ currentPage = 'visualization' }: Props) {
  const { logout, user } = useAuth();
  const { displayName, tenantName } = useAdmin();
  const isCustomerPage = currentPage === 'customer';
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  const handleLogout = async () => {
    try { await logout(); } catch (error) { console.error('Logout error:', error); }
  };

  const menuItems: MenuItem[] = [
    { label: 'Sign Out', onClick: () => { void handleLogout(); }, isAction: true },
  ];

  return (
    <div className="burger-menu" ref={menuRef}>
      {user?.photoURL ? (
        <img
          src={user.photoURL}
          alt="User Profile"
          id="account-btn"
          onClick={() => { console.log('[BurgerMenu] Profile image clicked, opening menu'); setIsOpen(!isOpen); }}
          style={{ cursor: 'pointer', pointerEvents: 'auto', width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover' }}
        />
      ) : (
        <span
          className="material-symbols-outlined"
          id="account-btn"
          onClick={() => { console.log('[BurgerMenu] Button clicked, opening menu'); setIsOpen(!isOpen); }}
          style={{ cursor: 'pointer', pointerEvents: 'auto' }}
        >
          account_circle
        </span>
      )}
      <div className={`dropdown-content ${isOpen ? 'show' : ''}`} id="dropdown-menu">
        <div className="dropdown-inner">
        {isCustomerPage && (
          <div className="burger-menu-user-info">
            <div className="burger-menu-avatar">
              {displayName ? displayName.charAt(0).toUpperCase() : '?'}
            </div>
            <div className="burger-menu-user-details">
              {displayName && <span className="burger-menu-name">{displayName}</span>}
              {tenantName && <span className="burger-menu-tenant">{tenantName}</span>}
              {user?.email && <span className="burger-menu-email">{user.email}</span>}
            </div>
          </div>
        )}
        {menuItems.map((item, index) => {
          if (item.isAction) {
            return (
              <a key={index} href="#" onClick={(e) => { e.preventDefault(); item.onClick?.(); }}>
                {item.label}
              </a>
            );
          }
          if (item.external) {
            return <a key={index} href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a>;
          }
          return <a key={index} href={item.href}>{item.label}</a>;
        })}
        </div>
      </div>
    </div>
  );
}
